import { ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LANGUAGE_CONFIG } from '@config/language.config';
import { AuthenticationGuard } from '@core/guards/authentication.guard';
import { MenuGuard } from '@core/guards/menu.guard';
import {
  AccountingEventsListComponent,
} from '@modules/accounting-events/accounting-events-list/accounting-events-list.component';
import {
  AccountingGroupsListComponent,
} from '@modules/accounting-groups/accounting-groups-list/accounting-groups-list.component';
import {
  BalanceInterfaceDownloadComponent,
} from '@modules/accounting/balance-interface-download/balance-interface-download.component';
import {
  MasterTransfersDownloadComponent,
} from '@modules/accounting/master-transfers-download/master-transfers-download.component';
import {
  MovementInterfaceDownloadComponent,
} from '@modules/accounting/movement-interface-download/movement-interface-download.component';
import {
  TransactionsEventsDownloadComponent,
} from '@modules/accounting/transactions-events-download/transactions-events-download.component';
import {
  TransactionsEventsLogDownloadComponent,
} from '@modules/accounting/transactions-events-log-download/transactions-events-log-download.component';
import {TotalsCostsDownloadComponent} from '@modules/accounting/totals-costs-download/totals-costs-download.component';
import { AmlLimitsListComponent } from '@modules/aml-limits/aml-limits-list/aml-limits-list.component';
import { ChannelsListComponent } from '@modules/channels/channels-list/channels-list.component';
import { CommissionsListComponent } from '@modules/commissions/commissions-list/commissions-list.component';
import { ConstantsListComponent } from '@modules/constants/constants-list/constants-list.component';
import { CustomersFilterComponent } from '@modules/customers/customers-filter/customers-filter.component';
import { HomeComponent } from '@modules/home/home.component';
import { LoginComponent } from '@modules/login/login.component';
import { PaymentMethodsListComponent } from '@modules/payment-methods/payment-methods-list/payment-methods-list.component';
import { RolesListComponent } from '@modules/roles/roles-list/roles-list.component';
import { RulesListComponent } from '@modules/rules/rules-list/rules-list.component';
import { SegmentsListComponent } from '@modules/segments/segments-list/segments-list.component';
import { StatusListComponent } from '@modules/status/status-list/status-list.component';
import {
  TransactionalEventsListComponent,
} from '@modules/transactional-events/transactional-events-list/transactional-events-list.component';
import {
  TransfersCustomerFilterComponent,
} from '@modules/transfers/transfers-customer-filter/transfers-customer-filter.component';
import {
  TransfersReferenceFilterComponent,
} from '@modules/transfers/transfers-reference-filter/transfers-reference-filter.component';
import { UsersListComponent } from '@modules/users/users-list/users-list.component';
import { TemplatesListComponent } from './modules/templates/templates-list/templates-list.component';

const lang = LANGUAGE_CONFIG;

export const appRoutes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthenticationGuard],
    data: { breadcrumb: lang.menu.home, parent: '' }
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthenticationGuard],
    data: { breadcrumb: lang.menu.home, parent: '' }
  },
  {
    path: 'canales',
    component: ChannelsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.channels,
      parent: lang.menu.generalParameters
    }
  },
  {
    path: 'clientes',
    component: CustomersFilterComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.customersFilter,
      parent: lang.menu.amlLimits
    }
  },
  {
    path: 'comisiones',
    component: CommissionsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.commissions,
      parent: ''
    }
  },
  {
    path: 'constantes',
    component: ConstantsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.constants,
      parent: lang.menu.generalParameters
    }
  },
  {
    path: 'estados',
    component: StatusListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.status,
      parent: lang.menu.generalParameters
    }
  },
  {
    path: 'eventos-contables',
    component: AccountingEventsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.accountingEvents,
      parent: lang.menu.generalParameters
    }
  },
  {
    path: 'eventos-transaccionales',
    component: TransactionalEventsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.transactionalEvents,
      parent: lang.menu.generalParameters
    }
  },
  {
    path: 'giros-cliente',
    component: TransfersCustomerFilterComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.transfersCustomer,
      parent: lang.menu.transfers
    }
  },
  {
    path: 'giros-referencia',
    component: TransfersReferenceFilterComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.transfersReference,
      parent: lang.menu.transfers
    }
  },
  {
    path: 'grupos-contables',
    component: AccountingGroupsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.accountingGroups,
      parent: lang.menu.generalParameters
    }
  },
  {
    path: 'interfaz-movimientos',
    component: MovementInterfaceDownloadComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.movementInterface,
      parent: lang.menu.accounting
    }
  },
  {
    path: 'interfaz-saldos',
    component: BalanceInterfaceDownloadComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.balanceInterface,
      parent: lang.menu.accounting
    }
  },
  {
    path: 'maestro-giros',
    component: MasterTransfersDownloadComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.masterTransfers,
      parent: lang.menu.accounting
    }
  },
  {
    path: 'medios-pago',
    component: PaymentMethodsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.paymentMethods,
      parent: lang.menu.generalParameters
    }
  },
  {
    path: 'plantillas',
    component: TemplatesListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: { breadcrumb: lang.menu.templates, parent: lang.menu.transfers }
  },
  {
    path: 'reglas',
    component: RulesListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: { breadcrumb: lang.menu.rules, parent: lang.menu.generalParameters }
  },
  {
    path: 'roles',
    component: RolesListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: { breadcrumb: lang.menu.roles, parent: lang.menu.accessControl }
  },
  {
    path: 'segmentos',
    component: SegmentsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.segments,
      parent: lang.menu.generalParameters
    }
  },
  {
    path: 'topes',
    component: AmlLimitsListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: { breadcrumb: lang.menu.limits, parent: lang.menu.amlLimits }
  },
  {
    path: 'transacciones-eventos',
    component: TransactionsEventsDownloadComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.transactionsEvents,
      parent: lang.menu.accounting
    }
  },  
  {
    path: 'transacciones-log-eventos',
    component: TransactionsEventsLogDownloadComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.logReport,
      parent: lang.menu.accounting
    }
  },
  {
    path: 'totals-costs',
    component: TotalsCostsDownloadComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: {
      breadcrumb: lang.menu.totalCosts,
      parent: lang.menu.accounting
    }
  },
  {
    path: 'usuarios',
    component: UsersListComponent,
    canActivate: [AuthenticationGuard, MenuGuard],
    data: { breadcrumb: lang.menu.users, parent: lang.menu.accessControl }
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthenticationGuard]
  },
  { path: '**', redirectTo: 'home' }
];

export const AppRoutingProviders: any[] = [];

export const Routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, {
  useHash: true
});
